import { useContext } from "react";

import { RuntimeContext } from "./RuntimeProvider";

export const useRuntime = () => useContext(RuntimeContext);
